/* istanbul ignore file */

import {
  bankLinkSuccessCoreContinue,
  institutionsCoreSkip,
  portfolioTieredContinue,
  signupCoreContinue,
  startInvestingCoreNext,
} from '../../redirects'
import { FlowEntry, FlowRoute } from '../../types'

const tiered: FlowEntry[] = [
  {
    page: FlowRoute.Welcome,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.Signup,
      },
    ],
    progress: {
      stepIndex: -1,
      stepPartialProgress: 0.1,
      stepOverallProgress: 0,
    },
  },
  {
    page: FlowRoute.SelectTier,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.Signup,
      },
      {
        name: 'invest_continue',
        goTo: () => FlowRoute.InvestInterstitial,
      },
    ],
    progress: {
      stepIndex: -1,
      stepPartialProgress: 0.1,
      stepOverallProgress: 0,
    },
  },
  {
    page: FlowRoute.Signup,
    actions: [
      {
        name: 'continue',
        stepEvent: 'create_account',
        goTo: () => FlowRoute.PersonalInfo,
      },
      {
        name: 'direct-to-mobile',
        stepEvent: 'direct_to_mobile',
        goTo: () => FlowRoute.DirectToMobileLander,
      },
      {
        name: 'moc-onboarding',
        stepEvent: 'moc-onboarding',
        goTo: () => FlowRoute.MOCInterstitial,
      },
      {
        name: 'select-tier',
        goTo: () => FlowRoute.SelectTier,
      },
    ],
    progress: {
      stepIndex: 0,
      stepPartialProgress: 0,
      stepOverallProgress: 5,
    },
  },
  {
    page: FlowRoute.DirectToMobileLander,
    actions: [
      {
        name: 'skip',
        stepEvent: 'skip_download_after_creds',
        goTo: () => FlowRoute.PersonalInfo,
      },
    ],
    progress: {
      stepIndex: 0,
      stepPartialProgress: 0,
      stepOverallProgress: 25,
    },
  },
  {
    page: FlowRoute.Funding,
    actions: [
      {
        name: 'partner_skip',
        goTo: signupCoreContinue,
      },
      {
        name: 'continue',
        stepEvent: 'link_bank_interstitial',
        goTo: () => FlowRoute.Institutions,
      },
      {
        name: 'skip',
        goTo: institutionsCoreSkip,
      },
      {
        name: 'choose',
        goTo: () => FlowRoute.ChooseFundingSource,
      },
      {
        name: 'manual',
        goTo: () => FlowRoute.ManualFundingSource,
      },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 0,
      stepOverallProgress: 10,
    },
  },
  {
    page: FlowRoute.Institutions,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'direct', goTo: () => FlowRoute.DirectBankIntegration },
      { name: 'skip', goTo: institutionsCoreSkip },
      { name: 'partner_skip', goTo: institutionsCoreSkip },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.PlaidLinkRedirect,
    actions: [
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.DirectBankIntegration,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'partner_skip', goTo: institutionsCoreSkip },
      { name: 'skip', goTo: institutionsCoreSkip },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.ManualFundingSource,
    actions: [
      { name: 'skip', goTo: institutionsCoreSkip },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.ChooseFundingSource,
    actions: [
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.BankLinkSuccess,
    actions: [
      { name: 'continue', goTo: bankLinkSuccessCoreContinue },
      { name: 'skip', goTo: bankLinkSuccessCoreContinue },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 65,
      stepOverallProgress: 20,
    },
  },
  {
    page: FlowRoute.PricingInterstitial,
    actions: [
      {
        name: 'continue',
        stepEvent: 'pricing_interstitial',
        goTo: () => FlowRoute.InvestInterstitial,
      },
      {
        name: 'select-tier',
        stepEvent: 'select_tier_from_interstitial',
        goTo: () => FlowRoute.SelectTier,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 0,
      stepOverallProgress: 25,
    },
  },
  {
    page: FlowRoute.MOCInterstitial,
    actions: [
      { name: 'continue', stepEvent: 'moc_interstitial', goTo: () => FlowRoute.PersonalInfo },
      { name: 'skip', stepEvent: 'moc_interstitial', goTo: () => FlowRoute.PersonalInfo },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 0,
      stepOverallProgress: 25,
    },
  },
  {
    page: FlowRoute.PersonalInfo,
    actions: [
      { name: 'continue', stepEvent: 'information_personal', goTo: () => FlowRoute.ContactInfo },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 0,
      stepOverallProgress: 25,
    },
  },
  {
    page: FlowRoute.ContactInfo,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_contact',
        goTo: () => FlowRoute.MFASetup,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 75,
      stepOverallProgress: 30,
    },
  },
  {
    page: FlowRoute.MFASetup,
    actions: [
      {
        name: 'continue',
        stepEvent: 'setup_mfa',
        goTo: () => FlowRoute.SSN,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 75,
      stepOverallProgress: 30,
    },
  },
  {
    page: FlowRoute.SSN,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_ssn',
        goTo: () => FlowRoute.InvestorQuestions,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 80,
      stepOverallProgress: 40,
    },
  },
  {
    page: FlowRoute.InvestInterstitial,
    actions: [
      {
        name: 'continue',
        stepEvent: 'invest_interstitial',
        goTo: () => FlowRoute.SuitabilityQuestions,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 80,
      stepOverallProgress: 40,
    },
  },
  {
    page: FlowRoute.SuitabilityQuestions,
    actions: [
      {
        name: 'continue',
        stepEvent: 'portfolio_questions',
        goTo: () => FlowRoute.Analyzing,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 92,
      stepOverallProgress: 60,
    },
  },
  {
    page: FlowRoute.InvestorQuestions,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_investor_questions',
        goTo: () => FlowRoute.Funding,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 85,
      stepOverallProgress: 50,
    },
  },
  {
    page: FlowRoute.Analyzing,
    actions: [
      {
        name: 'continue',
        stepEvent: 'analyzing_portfolio',
        goTo: () => FlowRoute.PreviewPortfolio,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 90,
      stepOverallProgress: 60,
    },
  },
  {
    page: FlowRoute.SecondChanceBankLink,
    actions: [{ name: 'continue', goTo: () => FlowRoute.Institutions }],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 90,
    },
  },
  {
    page: FlowRoute.PreviewPortfolio,
    actions: [
      { name: 'continue', stepEvent: 'portfolio_breakdown', goTo: portfolioTieredContinue },
      {
        name: 'about_portfolio',
        stepEvent: 'about_portfolio',
        goTo: () => FlowRoute.AboutPortfolio,
      },
      {
        name: 'add_bitcoin_etf',
        stepEvent: 'portfolio_breakdown',
        goTo: () => FlowRoute.CryptoLander,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 94,
      stepOverallProgress: 70,
    },
  },
  {
    page: FlowRoute.CryptoLander,
    actions: [
      {
        name: 'update_crypto_portfolio',
        stepEvent: 'portfolio_breakdown',
        goTo: () => FlowRoute.PreviewPortfolio,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 94,
      stepOverallProgress: 70,
    },
  },
  {
    page: FlowRoute.AboutPortfolio,
    actions: [{ name: 'goBack', stepEvent: 'goBack', goTo: () => FlowRoute.PreviewPortfolio }],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 94,
      stepOverallProgress: 70,
    },
  },
  {
    page: FlowRoute.RoundUpsInterstitial,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.RoundUpsSetup },
      { name: 'skip', goTo: () => FlowRoute.RecurringInvestment },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.RoundUpsSetup,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.RoundUpsFunding },
      { name: 'goBack', stepEvent: 'goBack', goTo: () => FlowRoute.RoundUpsInterstitial },
      { name: 'skip', goTo: () => FlowRoute.RecurringInvestment },
    ],

    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.RoundUpsFunding,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.RoundUpsPast },
      { name: 'goBack', stepEvent: 'goBack', goTo: () => FlowRoute.RoundUpsSetup },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.RoundUpsPast,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.RecurringInvestment },
      { name: 'goBack', goTo: () => FlowRoute.RoundUpsFunding },
    ],

    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.OneTimeInvestment,
    actions: [
      { name: 'continue', stepEvent: 'initial_investment', goTo: startInvestingCoreNext },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
    ],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 90,
    },
  },
  {
    page: FlowRoute.RecurringInvestment,
    actions: [
      {
        name: 'one-time',
        stepEvent: 'initial_investment',
        goTo: () => FlowRoute.OneTimeInvestment,
      },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'continue', stepEvent: 'initial_investment', goTo: startInvestingCoreNext },
    ],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 90,
    },
  },
  {
    page: FlowRoute.Success,
    actions: [{ name: 'referral-reward', goTo: () => FlowRoute.ReferralReward }],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 100,
    },
  },
  {
    page: FlowRoute.ReferralReward,
    actions: [{ name: 'continue', goTo: () => FlowRoute.ReferralDisclosure }],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 95,
    },
  },
  {
    page: FlowRoute.ReferralDisclosure,
    actions: [{ name: 'continue', goTo: () => FlowRoute.Success }],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 95,
    },
  },
  /**
   * This route belongs to the MOC flow, but we need to add it here
   * in order to handle Card Order HardFail users who then get switched to the tiered funnel.
   * If they hit the back button, this route here will render
   */
  {
    page: FlowRoute.CardOrderReview,
    actions: [
      {
        name: 'continue',
        stepEvent: 'card_order_review',
        goTo: () => FlowRoute.Funding,
      },
    ],
  },
]

export default tiered
